import {
  Button,
  Card,
  CardContent,
  FormControl,
  Grid,
  Icon,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography,
  Tooltip
} from "@material-ui/core";
import FormCheckbox from "components/Wrappers/materialUIWrappers/components/FormCheckbox.jsx";
import FormInput from "components/Wrappers/materialUIWrappers/components/FormInput";
import NumberInput from "components/Wrappers/materialUIWrappers/components/NumberInput";
import { RemoveField } from "helpers/ReduxHelpers";
import _ from "lodash";
import React, { Fragment } from "react";
import { change, Field , propTypes} from "redux-form";
import store from "store";
import CustomCardHeading from "../components/CustomCardHeading.jsx";
import DescriptiveRow from "../components/DescriptiveRow.jsx";
import { assetItems } from "./objects/assetItems";
import FormDropdown from 'components/Wrappers/materialUIWrappers/components/FormDropDown';
import GridItem from "components/Grid/GridItem.jsx";

const colwidth = value => {
  return {
    width: value,
    minWidth: value,
    maxWidth: value,
    margin: "0px"
  };
};

const CustomField = props => (
  <TableCell className="cellPaddingSmall">
    <FormControl fullWidth >
      <Field {...props} />
    </FormControl>
  </TableCell>
);

const CustomField2 = props => (
  
    <FormControl fullWidth style={{ bottom: "10px" }}>
      <Field {...props} />
    </FormControl>
  
);



function isInteger(value) {
  return /^\d+$/.test(value);
}

const percentage = value => {
  if (value === undefined) return undefined;

  if (isNaN(value)) {
    return "Must be a number";
  }

  if (parseInt(value, 10) >= 101 || parseInt(value, 10) < 0) {
    return "Not a valid Percentage";
  }

  return undefined;
};


const hundred = value => {
  if (value === undefined) return undefined;

  if (isNaN(value)) {
    return "Must be a number";
  }

  if (parseInt(value, 10) !== 100) {
    return "Must add up to 100";
  }

  return undefined;
};

var asset = value => {
  return (
    {
      category: "",
      description: "",
      ownershipClient: 0,
      ownershipSpouse: 0,
      ownershipOther: 0,
      cgtPayable: false,
      marketValue: 0,
      baseCost: 0,
      liability: 0,
      liquid: false,
      estateInherit: 0,
      spouseInherit: 0,
      dependentsInherit: 0,
      trustInherit: 0,
      otherInherit: 0,
      charityInherit: 0,
      deleted: false
    }
  )
}

class Assets extends React.Component {

   required = (value, a, b, c) => 
   {
     this.props.changeTab();
    console.log("req check", value, " ", a, " ", b, " ", c, " ");
    
    var i = c.split(".")[2]
    console.log(i, " --> ", this.props.state.assets.length , " ---> ", this.props.state.assets[i].deleted, " ---> ", a.state.assets[i], " ---> ", JSON.stringify(this.props.state.deleted))
    
    
    
    if(this.props.state.assets[i].deleted)
    {
      console.log("WE MUST RETURN THE SLAB")
      return;
    }
      
      
    return value ? undefined : "Required";
  };

  
  mustBeFullPercentage = (value, a, b, c) =>
{
  var i = c.replace("asset.ownershipClient.", "").replace("asset.ownershipSpouse.", "").replace("asset.ownershipOther.", "")
  var asset = this.props.state.assets[i]
  var fullPercentage = parseInt(asset.ownershipClient) + parseInt(asset.ownershipSpouse) + parseInt(asset.ownershipOther);

  console.log("Testing persentage " + i + " " + JSON.stringify(asset))
  if(fullPercentage != 100)
    return "Must add up to 100";

  return undefined;
}


  componentDidMount() {
    this.props.scrollMeBar();
  }

  componentDidUpdate()
  {
    // Initializing dynamic fields. See initializeDynamicField decleration for structure.
     var fields = 
     [
      {
        field: "assets",      
        fieldName: "asset.ownershipClient.",  
        fieldVar: "ownershipClient",   
        value: "100", 

      },
      {
        field: "assets",      
        fieldName: "asset.ownershipSpouse.",  
        fieldVar: "ownershipSpouse",   
        value: "0",     
      },
      {
        field: "assets",      
        fieldName: "asset.ownershipOther.",  
        fieldVar: "ownershipOther",   
        value: "0",     
      },
      {
        field: "assets",      
        fieldName: "asset.cgtPayable.",  
        fieldVar: "cgtPayable",   
        value: true, 
        conditions:
        [
          {
            condition: "category", 
            param: "other_residential" ,    
            falseValue: false
          },
          {
            condition: "category", 
            param: "primary_residential" ,    
            falseValue: false
          },
          {
            condition: "category", 
            param: "jse_shares" ,    
            falseValue: false
          },
          {
            condition: "category", 
            param: "farms_owned" ,    
            falseValue: false
          },
          {
            condition: "category", 
            param: "investments" ,    
            falseValue: false
          },
          {
            condition: "category", 
            param: "interest_in_partnership" ,    
            falseValue: false
          },
          {
            condition: "category", 
            param: "interest_in_close_corporation" ,    
            falseValue: false
          },
          {
            condition: "category", 
            param: "shareholding_in_private_company" ,    
            falseValue: false
          }
        ]    
      },
      {
        field: "assets",      
        fieldName: "asset.liability.",  
        fieldVar: "liability",   
        value: "0",     
      }
     ]


     if(this.props.state.changes1)
      this.props.initializeDynamicField("assetsInit", fields);
    
  }

  addNew = () => {
    var assets = this.props.state.assets;
    assets.push(asset());
    this.props.addNew(assets);
    
    console.log("--->} " + JSON.stringify(this.props.state.assets))
  }

  remove = (n) => {
    var assets = this.props.state.assets;
    var newAss = [];
    var node = n.target;
    
    while(node.nodeName != "BUTTON" && node.parentNode != null)
    {
      node = node.parentNode
    }
    
    var i = node.name.replace("remove", "")
    console.log(i)
    
    //assets.splice(i, 1)
    //assets[i] = null;
    assets.map((e,k) =>
    {
      if(e != assets[i])
        newAss[k] = e
      if(e == assets[i])
      {
        assets[i].deleted = true

        this.props.state.deleted.push(i)
      }
       
    })
    
    this.props.addNew(newAss);
  }

  changeCat = (value, name) => {
    var assets = this.props.state.assets;
    var asset = name.replace("asset.category.", "")
    assets[asset].category = value
    assets[asset].assetsInit[3] = null;
    this.props.changeAsset(assets);
  }

  changeDesc = (value, name) => {
    var assets = this.props.state.assets;
    var asset = name.replace("asset.description.", "")
    assets[asset].description = value
    this.props.changeAsset(assets);
  }

  changeOwnerC = (name, value) => {
    var assets = this.props.state.assets;
    console.log("---------) " + value + " " + name)
    var asset = name.replace("asset.ownershipClient.", "")
    assets[asset].ownershipClient = value
    this.props.changeAsset(assets);
  }

  changeOwnerS = (name, value) => {
    var assets = this.props.state.assets;
    var asset = name.replace("asset.ownershipSpouse.", "")
    assets[asset].ownershipSpouse = value
    this.props.changeAsset(assets);
  }

  changeOwnerO = (name, value) => {
    var assets = this.props.state.assets;
    var asset = name.replace("asset.ownershipOther.", "")
    assets[asset].ownershipOther = value
    this.props.changeAsset(assets);
  }

  changeCgt = (value, name) => {
    var assets = this.props.state.assets;
    var asset = name.replace("asset.cgtPayable.", "")
    assets[asset].cgtPayable = value
    this.props.changeAsset(assets);
    console.log("=====> " + value + " " + JSON.stringify(this.props.state.assets[asset]))
  }

  changeMarket = (value, name) => {
    var assets = this.props.state.assets;
    var asset = name.replace("asset.marketValue.", "")
    assets[asset].marketValue = value
    this.props.changeAsset(assets);
  }

  changeBase = (value, name) => {
    var assets = this.props.state.assets;
    var asset = name.replace("asset.baseValue.", "")
    assets[asset].baseCost = value
    this.props.changeAsset(assets);
  }

  changeLiable = (value, name) => {
    var assets = this.props.state.assets;
    var asset = name.replace("asset.liability.", "")
    assets[asset].liability = value
    this.props.changeAsset(assets);
  }

  checkItem = (label, name, changeFunc) => {
    return (
      
              <FormControl style={{marginBottom: "-30px", paddingBottom: "-30px"}}>
                <Field
                  component={FormCheckbox}
                  name={name}
                  onChange={(e, f, g, h) => {
                    changeFunc(f, h)

                  }}

                />
              </FormControl>
           
    );
  };






  render() {
    let { checkValidation } = this.props;

    var clientD = "";
    if(this.props.state.client)
      clientD = this.props.state.client.first_name + " " + this.props.state.client.surname

    return (
      <div className="contentWithStepper" style={{ width: "120%", marginLeft: "-10%" , height:"fit-content"}}>
        <Card >
          <CardContent>
            <CustomCardHeading
              subheading={"Financial Needs Analysis"}
              caption={clientD}
              headline={"Assets"}
            />

            <Grid container spacing={24} className="customTableAutoGrid" >
              <Table className="customTable1">
                <TableHead className="fixedHead">
                  <TableRow>
                    <TableCell
                      className="cellPaddingTiny"
                      style={colwidth("23em")}
                      rowSpan={2}
                    >
                      <Typography style={{ fontSize: '16px', textAlign: "center" }}>Category</Typography>

                    </TableCell>
                    <TableCell
                      className="cellPaddingSmall"
                      style={colwidth("15em")}
                      rowSpan={2}
                    >
                      <Typography style={{ fontSize: '16px' }}>
                        Asset Description
                      </Typography>

                    </TableCell>
                    <TableCell
                      className="cellPaddingTiny"
                      style={colwidth("16em")}
                      colSpan={3}

                    >
                      <Typography style={{ fontSize: '16px', textAlign: "center", verticalAlign: 'bottom' }}>
                        Ownership
                      </Typography>

                    </TableCell>

                    <TableCell
                      className="cellPaddingSmall"
                      style={colwidth("6em")}
                      rowSpan={2}
                    >
                      <Typography style={{ fontSize: '16px', textAlign: "center" }}>CGT Payable?</Typography>

                    </TableCell>

                    <TableCell
                      className="cellPaddingSmall"
                      style={colwidth("8em")}
                      rowSpan={2}
                    >
                      <Typography style={{ fontSize: '16px', textAlign: "center" }}>Base Cost</Typography>

                    </TableCell>

                    <TableCell
                      className="cellPaddingSmall"
                      style={colwidth("8em")}
                      rowSpan={2}
                    >
                      <Typography style={{ fontSize: '16px', textAlign: "center" }}>Market Value</Typography>

                    </TableCell>

                    <TableCell
                      className="cellPaddingSmall"
                      style={colwidth("8em")}
                      rowSpan={2}
                    >
                      <Typography style={{ fontSize: '16px', textAlign: "center" }}>Liability</Typography>

                    </TableCell>
                  </TableRow>
                  <TableRow >

                    <TableCell
                      className="cellPaddingSmall"


                    >
                      <Typography style={{ fontSize: '16px', textAlign: "center" }}>
                        Client
                      </Typography>

                    </TableCell>
                    <TableCell
                      className="cellPaddingSmall"

                    >
                      <Typography style={{ fontSize: '16px', textAlign: "center" }}>Spouse </Typography>

                    </TableCell>
                    <TableCell
                      className="cellPaddingSmall"

                    >
                      <Typography style={{ fontSize: '16px', textAlign: "center" }}>Other </Typography>

                    </TableCell>

                  </TableRow>
                </TableHead>
                <TableBody>

                  {this.props.state.assets.map((e, i) => {

                    return (
                      <TableRow key={i}>
                        

                        <TableCell>
                          <Button
                            name={"remove" + i}
                            key = {"remove" + i}
                            variant="fab"
                            mini
                            className="minifab"
                            color="primary"
                            style={{ left: "-20px", top: "-5px" }}
                            onClick={(e) =>{e.stopPropagation(); this.remove(e)}}
                          >
                            <Icon style={{ color: "white" }}>remove</Icon>
                          </Button>
                          <CustomField2
                            name={"asset.category." + i}
                            component={FormDropdown}
                            checkValidation={this.props.checkValidation}
                            label={''}
                            isrequired={true}
                            
                            //validate={[required]}
                            options={assetItems}
                            onChange={(e, value, t, name) => this.changeCat(value, name)}
                            
                            
                          />
                        </TableCell>
                        

                        

                        <CustomField
                          name={'asset.description.' + i}
                          component={FormInput}
                          checkValidation={this.props.checkValidation}
                          label={'description'}
                          isrequired={false}
                          validate={[this.required]}
                          onChange={(e, value, t, name) => this.changeDesc(value, name)}
                        />

                        <CustomField
                          name={'asset.ownershipClient.' + i}
                          suffix="%"
                          component={NumberInput}
                          checkValidation={this.props.checkValidation}
                          label={'%*'}
                          isrequired={true}
                          validate={[this.required,this.mustBeFullPercentage]}
                          onChange = {(e, f, g, h) => 
                            {
                              this.changeOwnerC(h,f)
                            }}
                        />

                        <CustomField
                          name={'asset.ownershipSpouse.' + i}
                          suffix="%"
                          component={NumberInput}
                          checkValidation={this.props.checkValidation}
                          label={'%*'}
                          isrequired={true}
                          validate={[this.required,this.mustBeFullPercentage]}
                          onChange = {(e, f, g, h) => 
                            {
                              this.changeOwnerS(h,f)
                            }}
                        />

                        <CustomField
                          name={'asset.ownershipOther.' + i}
                          suffix="%"
                          component={NumberInput}
                          checkValidation={this.props.checkValidation}
                          label={'%*'}
                          isrequired={true}
                          validate={[this.required,this.mustBeFullPercentage]}
                          onChange = {(e, f, g, h) => 
                            {
                              this.changeOwnerO(h,f)
                            }}
                        />

                        <TableCell className="cellPaddingSmall">
                          {this.checkItem("", "asset.cgtPayable." + i, this.changeCgt)}
                        </TableCell>

                        {this.props.state.assets[i].cgtPayable &&
                          <CustomField
                          name={'asset.baseValue.' + i}
                          prefix="R"
                          component={NumberInput}
                          checkValidation={this.props.checkValidation}
                          label={'R*'}
                          isrequired={true}
                          validate={[this.required]}
                          disabled={true}
                          onChange = {(e, f, g, h) => 
                            {
                              this.changeBase(f,h)
                            }}
                          />
                        }

                        {!this.props.state.assets[i].cgtPayable &&
                          <TableCell className="cellPaddingSmall">
                          </TableCell>
                        }


                        

                        <CustomField
                          name={'asset.marketValue.' + i}
                          prefix="R"
                          component={NumberInput}
                          checkValidation={this.props.checkValidation}
                          label={'R*'}
                          isrequired={false}
                          validate={[this.required]}
                          onChange = {(e, f, g, h) => 
                            {
                              this.changeMarket(f,h)
                            }}
                        />

                        <CustomField
                          name={'asset.liability.' + i}
                          prefix="R"
                          component={NumberInput}
                          checkValidation={this.props.checkValidation}
                          label={'R*'}
                          isrequired={true}
                          validate={[this.required]}
                          onChange = {(e, f, g, h) => 
                            {
                              this.changeLiable(f,h)
                            }}
                        />
                      </TableRow>

                    )

                  })}

                  <TableRow>
                    <Table style={{ width: "10em" }}>
                      <DescriptiveRow

                        description={"Add Asset"}
                        add={() =>
                          this.addNew()
                        }

                        extraCells={10}
                      />
                    </Table>
                  </TableRow>

                </TableBody>
              </Table>

            </Grid>
          </CardContent>
        </Card>
      </div>
    );
  }
}

export default Assets;







// WEBPACK FOOTER //
// ./src/views/Fna/steps/Assets.jsx